import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIfArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={49}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="var(--color-border-base-secondary)"
      d="M15.5 12.25a1.5 1.5 0 0 1 1.5-1.5h22V7.987a1.333 1.333 0 0 1 2.04-1.13l6.817 4.26c.836.522.836 1.74 0 2.262l-6.817 4.26A1.333 1.333 0 0 1 39 16.51v-2.76H17a1.5 1.5 0 0 1-1.5-1.5"
    />
    <path
      fill="var(--color-surface-status-neutral-secondary)"
      d="M0 12c0-1.858 0-2.787.123-3.564A10 10 0 0 1 8.436.123C9.213 0 10.142 0 12 0h3c1.858 0 2.787 0 3.564.123a10 10 0 0 1 8.313 8.313C27 9.213 27 10.142 27 12s0 2.787-.123 3.564a10 10 0 0 1-8.313 8.313C17.787 24 16.858 24 15 24h-3c-1.858 0-2.787 0-3.564-.123a10 10 0 0 1-8.313-8.313C0 14.787 0 13.858 0 12"
    />
    <path
      fill="var(--color-content-base-primary)"
      d="M11.113 7.636v8.727H9.532V7.636zm1.712 8.727V7.636h5.59v1.326h-4.01v2.369h3.627v1.325h-3.627v3.707z"
    />
  </svg>
);
export default SvgIfArrow;
